import { getIsReady } from "@store/Store/Pages/ProductList/ProductListSelectors";
import { useSelector } from "react-redux";

const useIsReady = () => {
    return useSelector(getIsReady);
};

export default useIsReady;
